/**
 * @module lib/commercial/keytar/crosswords/template
 */
import Template, { BLOCKOUT_TYPES } from "lib/commercial/keytar/Template";
import { setUpModalView } from "lib/commercial/keytar/common/takeover";
import { removeAds, removeBody, removeElements, removeVideos } from "utils/dom-controller";
import { isDesktop } from "utils/detect";
import { configureModal } from "ui/modal-manager";
import consts from "lib/consts";

/** @type {String} */
const wallName = "crosswordsWall";

const blockoutType = isDesktop()
  ? BLOCKOUT_TYPES.EVERYTHING // static modal displayed
  : BLOCKOUT_TYPES.HEADER_NAV_ACCESSIBLE; // iframe takeover displayed

const props = {
  blockoutType,
  /**
   * @method render
   * @description Always render the paywall template.
   * @returns {Promise<Boolean>} true if rendered
   */
  render() {
    const url = consts.URLS.REGISTER.CROSSWORDS;

    const elementsToRemove = []; // nothing for now

    if (isDesktop()) {
      const modal = configureModal({
        uid: "regwall-crosswords",
        iframeUrl: url,
        scrollable: false,
        topPaddingForCloseButton: false,
        protectedModal: true,
        height: 820,
        onOpenModal: () => {
          removeElements(elementsToRemove);
          removeBody();
          removeAds();
          removeVideos();
        }
      });
      modal(); // display it now
    } else {
      setUpModalView(wallName, null, ["iframe"], elementsToRemove, [], url);
    }
    return Promise.resolve(true);
  }
};

export default new Template(props);
